import ApiResourceManager from '../ApiResourceManager';

// The platform agent's side of shop-backend (docs/platform-agent/contracts.md).
export default class PlatformAgentManager extends ApiResourceManager {
  // Who is asking and what Amigo may do for this restaurant (§2): `available`, the person, the areas.
  // 404 for a restaurant the person can't reach.
  getContext = () =>
    this.request({
      method: 'GET',
      url: '/platform-agent/context',
    });

  // Our team's Amigo log (§7, FoodAmigos roles only): the requests Amigo handled, newest first, 25 a page.
  // `params`: company_id, franchise_id, from, to, change_set_id, gap_id, page.
  getLog = (params = {}) =>
    this.request({
      method: 'GET',
      url: '/platform-agent/log',
      params,
    });

  // Couldn't do (§7): what Amigo couldn't do yet, grouped by what was asked, most asked first.
  // `params`: kinds (sent as kinds[], shop's default [not_covered]), area, from, to.
  getGaps = (params = {}) =>
    this.request({
      method: 'GET',
      url: '/platform-agent/gaps',
      params,
    });
}
